import { Component, HostListener } from '@angular/core';
import { FreezeTable } from './../app/shared/components/custom-table/custom-table.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';
import { ApplicationInsightsService } from './shared/services/application-insights.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CookieService } from 'ngx-cookie-service';
import { CookieComponent } from './shared/components/cookie/cookie.component';
import { Subject, Subscription, timer } from 'rxjs';
import { NotificationTimeoutComponent } from './shared/components/notification-timeout/notification-timeout.component';
import { MatDialog } from '@angular/material/dialog';
import { MaintenanceService } from 'src/app/shared/services/maintenance.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { PortalTypeEnum } from './shared/general/portal-type-enum';
import { Maintenance, MaintenanceBeforeHour, MaintenanceBeforeMinute } from './shared/models/maintenance.model';
import { FieldLength } from './shared/general/field-length';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { DialogComponent } from './shared/components/dialog/dialog.component';
import { WarningMessageEnum } from './shared/general/warning-message.enum';
import { DataService } from './core/data.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ClientApp';
  freezeData: FreezeTable = new FreezeTable();
  userInactive: Subject<any> = new Subject();
  duration: number = 55 * 60 * 1000;
  isTerm: boolean = true;
  hideTimeout: boolean = false;
  timeoutId;
  maintenanceDetail: Maintenance = new Maintenance();
  maintenanceTimer: Subscription;
  public fieldLength = FieldLength;
  constructor(public route: ActivatedRoute, public applicationInsightsService: ApplicationInsightsService,
    private _bottomSheet: MatBottomSheet,
    private cookieService: CookieService, private dialog: MatDialog, private router: Router,
    private maintenanceService: MaintenanceService, private spinnerService: NgxSpinnerService,
    private locationStrategy: LocationStrategy,private dataService: DataService) {

    this.freezeData.isThirdColum = true
    this.freezeData.className = 'detailspage'
    this.checkTimeOut();
    this.userInactive.subscribe(() => {
      {
        if (this.hideTimeout) {
          clearTimeout(this.timeoutId);
          this.checkTimeOut();
        }
        else if (this.isTerm) {
          clearTimeout(this.timeoutId);
          this.checkTimeOut(); this.isTerm = false;
        }
      }
    }
    );
  }
  checkTimeOut() {
    this.timeoutId = setTimeout(
      () => this.userInactive.next(this.openDialog()), this.duration
    );
  }
  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  @HostListener('window:mousemove')
  checkUserActivity() {
    if (this.isTerm) {
      clearTimeout(this.timeoutId);
      this.checkTimeOut();
    }
  }
  ngOnInit() {
    if (!this.cookieService.check("OptanonAlertBoxClosed")) {
      this._bottomSheet.open(CookieComponent, { disableClose: true, panelClass: 'cookie-block' });
    }

    //initially set iServerUnavailable session as false
    sessionStorage.setItem("isServerUnavailable","false");
    //Logic to get Maintenance Details and set prior message
    this.spinnerService.show();
    this.maintenanceService.getMaintenanceDetail(PortalTypeEnum.CreditorCentralPortal, sessionStorage.getItem('userId') != "" && sessionStorage.getItem('userId') != null ? true : false, sessionStorage.getItem('userId'))
      .subscribe((maintenanceResponse: Maintenance) => {
        this.spinnerService.hide();
        if (maintenanceResponse != null && maintenanceResponse?.scheduledDateTime != null) {
          this.maintenanceDetail = maintenanceResponse;
          console.log("Maintenance Response- ", maintenanceResponse);
          //Set a session flag i maintenance has already started
          sessionStorage.setItem('isMaintenanceInProgress', this.maintenanceDetail.isMaintenanceInProgress.toString());
          if (this.maintenanceDetail.isMaintenanceInProgress) {
            this.router.navigate(['']);

            //Prevent back button
            this.preventBackButton();
          }
      
          //Set all maintenance Data in Service
          this.maintenanceService.setScheduledMaintenanceDateTime(this.maintenanceDetail?.scheduledDateTime);
          this.maintenanceService.setMaintenanceBeforeHourList(this.maintenanceDetail.maintenanceBeforeHourList);
          this.maintenanceService.setMaintenanceBeforeMinuteList(this.maintenanceDetail.maintenanceBeforeMinuteList);
          this.maintenanceService.setMaintenanceBeforeSecondList(this.maintenanceDetail.maintenanceBeforeSecondList);

          //Logic to remove past hour, minutes and seconds from the maintenance response list
          this.maintenanceService.removePastDateTime();
          //Invoke the subject to start the timer based on New user Registration
          this.maintenanceService.getMaintenanceWarningPopupSubject().subscribe((maintenanceSubjectResponse) => {
            if (maintenanceSubjectResponse) {
              //Set a session variable to handle the browser refresh case. Both BehaviorSubject and timer will get reset
              // upon browser refresh. So check if session has value then continue the timer to run
              sessionStorage.setItem("isMaintenanceTimerInProgress", "true");

              //Reset the timer if its already set
              this.unsubscribeMaintenanceTimer();
              //Start the timer once New Registration is clicked or As Post Login
              this.maintenanceTimer = timer(this.fieldLength.MillisecondsPerSecond * parseInt(environment.maintenanceTimerSeconds), this.fieldLength.MillisecondsPerSecond * parseInt(environment.maintenanceTimerSeconds))
                .subscribe(timerSubscription => {
                  console.log("**Timer Running***");
                  this.validateCurrentMaintenanceTime();
                });
            }
            else if (sessionStorage.getItem("isMaintenanceTimerInProgress") == "true") {
               //Reset the timer if its already set
               this.unsubscribeMaintenanceTimer();
              this.maintenanceTimer = timer(this.fieldLength.MillisecondsPerSecond * parseInt(environment.maintenanceTimerSeconds), this.fieldLength.MillisecondsPerSecond * parseInt(environment.maintenanceTimerSeconds))
                .subscribe(timerSubscription => {
                  console.log("Timer running by Session flag");
                  this.validateCurrentMaintenanceTime();
                });
            }
            else { }
          });
          //At first load start the timer from app component by subcribing to timer
          this.maintenanceService.setMaintenanceWarningPopupSubject(""+moment.utc().format('YYYY-MM-DD HH:mm:ss'));
        }
        else {
          //set no maintenace data
          sessionStorage.setItem('isMaintenanceInProgress', 'false');
        }

      });
  }
  //A method to calculate current time is equal to given before warning time
  validateCurrentMaintenanceTime() {
    let temporaryBeforeHourList: MaintenanceBeforeHour[] = [];
    let temporaryBeforeMinuteList: MaintenanceBeforeMinute[] = [];

    //Prepare local timezone data and check if maintenance has started
    //UTC to current local time
    let currentMaintenanceLocalTime = moment.utc(this.maintenanceDetail?.scheduledDateTime).local();
    //Remove Minutes and Milliseconds
    currentMaintenanceLocalTime = currentMaintenanceLocalTime.set({ second: 0, millisecond: 0 });
    //Prepare current local time and set time
    let currentUTCToLocalTime = moment.utc().local().set({ second: 0, millisecond: 0 });
    console.log("current maintenace time -", currentMaintenanceLocalTime.format('YYYY-MMM-DD h:mm ss A'));
    console.log("current UTC to local time -", currentUTCToLocalTime.format('YYYY-MMM-DD h:mm ss A'));
    console.log('Session isMaintenanceInProgress - ',sessionStorage.getItem('isMaintenanceInProgress'));
    //Check time reached to same as scheduled maintenance time
    if ((currentMaintenanceLocalTime.isSame(currentUTCToLocalTime) || currentUTCToLocalTime.isAfter(currentMaintenanceLocalTime))
      && (sessionStorage.getItem('isMaintenanceInProgress')=='false' || !sessionStorage.getItem('isMaintenanceInProgress'))) {
      console.log("***Deployment started***");
      //Set session as deployment started
      sessionStorage.setItem('isMaintenanceInProgress',"true");
      //Set IsMaintenanceProgress flag in model data to hide footer
      this.maintenanceDetail.isMaintenanceInProgress=true;
      //Get warning message based on New/Exising User
      let message: string = '';
      //Redirect to landing page based on new/existing user
      if (sessionStorage.getItem('userId')) {
        message = WarningMessageEnum.ExistingUserTerminationMessage;
      }
      else {
        message = WarningMessageEnum.NewUserTerminationMessage;
      }

      //Check user is in the landing page or terms and conditions page. If yes show other popup message
      let currentPathString = location.pathname;

      if (currentPathString=="/" || currentPathString=="/terms-and-conditions;isFromFooter=true"
       || currentPathString=="/about-us") {
        //Set popup message
        message = WarningMessageEnum.LandingPageTerminationPopup;
        const dialogRefLandingPage = this.dialog.open(DialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            oneButton: true,
            labelVal2: message,
            primaryButVal: 'OK',
            showMaintenanceIcon:true
          },
        });
        dialogRefLandingPage.afterClosed().subscribe((res) => {
          if (res.data == 'OK') {
            //to close all dialog if any opened in the screen
            this.dialog.closeAll();
            //this.unsubscribeMaintenanceTimer();
            //Add code to disable browser back button
            if (sessionStorage.getItem('userId')) {
              //Reset all edit lock values
              if (sessionStorage.getItem('isMyAccountEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.creditorId,
                  isScreenLock: false,
                  module: 'MyAccount'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear();
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else if (sessionStorage.getItem('isCreditorClaimEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.adjudicationId,
                  isScreenLock: false,
                  module: 'CreditorClaim'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear();
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else if (sessionStorage.getItem('isManageUsersEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.creditorUserId,
                  isScreenLock: false,
                  module: 'ManageUser'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear();
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else { }
              //Clear session and redirect to landing page
              sessionStorage.clear();
              //Set Maintenance is in progress
              sessionStorage.setItem('isMaintenanceInProgress', "true");
            }
            this.router.navigate(['']);
            //Reload current path if the user is in the landing page
            let currentPathString = location.pathname;
            if (currentPathString == "/") {
              this.reloadCurrentRoute();
            }
            //Set a session flag to prevent back button
            sessionStorage.setItem("preventBackButton", "true");
          }
        });
      }
      //show dialog message for all other screens except Landing page, terms and condition and contact-us
      else {
        const dialogRefDuplicate = this.dialog.open(DialogComponent, {
          disableClose: true,
          width: '500px',
          data: {
            oneButton: true,
            labelVal2: message,
            primaryButVal: 'OK',
            showMaintenanceIcon: true
          },
        });
        dialogRefDuplicate.afterClosed().subscribe((res) => {
          if (res.data == 'OK') {
            //to close all dialog if any opened in the screen
            this.dialog.closeAll();
            //this.unsubscribeMaintenanceTimer();
            //Add code to disable browser back button
            if (sessionStorage.getItem('userId')) {
              //Reset all edit lock values
              if (sessionStorage.getItem('isMyAccountEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.creditorId,
                  isScreenLock: false,
                  module: 'MyAccount'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear(); 
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else if (sessionStorage.getItem('isCreditorClaimEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.adjudicationId,
                  isScreenLock: false,
                  module: 'CreditorClaim'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear();
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else if (sessionStorage.getItem('isManageUsersEdit') == 'true') {
                let lockDetails: any = {
                  lockId: this.dataService.creditorUserId,
                  isScreenLock: false,
                  module: 'ManageUser'
                }
                this.dataService.postRequest('general/updatelock', lockDetails).subscribe((response) => {
                  sessionStorage.clear();
                  //Set Maintenance is in progress
                  sessionStorage.setItem('isMaintenanceInProgress', "true");
                  this.navigateToMaintenanceScreen();
                });
              }
              else { }
              //Clear session and redirect to landing page
              sessionStorage.clear();
              //Set Maintenance is in progress
              sessionStorage.setItem('isMaintenanceInProgress', "true");
            }
            this.router.navigate(['']);
            //Reload current path if the user is in the landing page
            let currentPathString = location.pathname;
            if (currentPathString == "/") {
              this.reloadCurrentRoute();
            }
            //Set a session flag to prevent back button
            sessionStorage.setItem("preventBackButton", "true");

          }
        });
      }
    }
    //Check Before Minute time and show the warning popup. Then remove the index from the list after displaying warning popup.
    else if (this.maintenanceService.maintenanceBeforeHourList.length > 0) {
      for (let index = 0; index < this.maintenanceService.maintenanceBeforeHourList.length; index++) {
        let subtractedHourDateTime = moment.utc(this.maintenanceDetail?.scheduledDateTime).local().subtract({ hours: this.maintenanceService.maintenanceBeforeHourList[index].hour }).local();
        subtractedHourDateTime = subtractedHourDateTime.set({ second: 0, millisecond: 0 });
        let currentLocalTime = moment.utc().local().set({ second: 0, millisecond: 0 });
        console.log("Subtracted Local Time - ", subtractedHourDateTime.format('YYYY-MMM-DD h:mm ss A'));
        console.log("System Current Local Time- ", currentLocalTime.format('YYYY-MMM-DD h:mm ss A'));
        if (subtractedHourDateTime.isSame(currentLocalTime) && (!this.maintenanceService.maintenanceBeforeHourList[index].isCompleted)) {
          //Set the index as completed
          this.maintenanceService.maintenanceBeforeHourList[index].isCompleted = true;
          //Add to temp list to remove after foreach
          temporaryBeforeHourList.push(this.maintenanceService.maintenanceBeforeHourList[index]);

          //Get warning message based on New/Exising User
          let message: any = this.maintenanceService.maintenanceBeforeHourList[index].warningMessage;
          message=message?.replaceAll("\\n","\n");
          
          console.log("Hour warnig message- ", message);
         
          //show dialog message only if the user is in other page except landing page and terms and condition
          //There should not be before hour & minute popup for landing page and T&C page
          let currentPathString = location.pathname;

          if (currentPathString!="/" && currentPathString!="/terms-and-conditions;isFromFooter=true"
          && currentPathString!="/about-us") {
            if (sessionStorage.getItem('userId')) {
              this.showMaintenanceForMinutesDialog(message);
            }else{
             this.showMaintenanceForHoursDialog(message);
            }
          }
          break;
        }
      }
      //Remove past date time actual list
      temporaryBeforeHourList.forEach((element) => {
        this.maintenanceService.maintenanceBeforeHourList = this.maintenanceService.maintenanceBeforeHourList.filter((data => data.hour != element.hour));
      });

      console.log("Final Hour Arraylist", this.maintenanceService.maintenanceBeforeHourList);
    }
    //Popup for before Minutes
    else if (this.maintenanceService.maintenanceBeforeMinuteList.length > 0) {
      for (let index = 0; index < this.maintenanceService.maintenanceBeforeMinuteList.length; index++) {
        let subtractedMinuteDateTime = moment.utc(this.maintenanceDetail?.scheduledDateTime).local().subtract({ minutes: this.maintenanceService.maintenanceBeforeMinuteList[index].minute }).local();

        subtractedMinuteDateTime = subtractedMinuteDateTime.set({ second: 0, millisecond: 0 });
        
        let currentLocalTime = moment.utc().local().set({ second: 0, millisecond: 0 });
        console.log("Subtracted Local Time - ", subtractedMinuteDateTime.format('YYYY-MMM-DD h:mm ss A'));
        console.log("System Current Local Time- ", currentLocalTime.format('YYYY-MMM-DD h:mm ss A'));
        if (subtractedMinuteDateTime.isSame(currentLocalTime) && (!this.maintenanceService.maintenanceBeforeMinuteList[index].isCompleted)) {
          //Only to set this session and it is required if overriding popup should not be there (two popup rasied one after the other)
          //So based on this value, system will not raise the second popup if one is rasied.
          //TO reset the session once popup is closed (User clicks OK in popup)
          //sessionStorage.setItem('isMaintenanceWarningPopupOpen', 'true');

          //Set the index as completed
          this.maintenanceService.maintenanceBeforeMinuteList[index].isCompleted = true;
          //Add to temp list to remove after foreach
          temporaryBeforeMinuteList.push(this.maintenanceService.maintenanceBeforeMinuteList[index]);

          //Get warning message based on New/Exising User
          let message: any = this.maintenanceService.maintenanceBeforeMinuteList[index].warningMessage;
          message=message?.replaceAll("\\n","\n");
          
          console.log("Warning message - ", message);

           //show dialog message only if the user is in other page except landing page and terms and condition
          //There should not be before hour & minute popup for landing page and T&C page
          let currentPathString = location.pathname;

          if (currentPathString!="/" && currentPathString!="/terms-and-conditions;isFromFooter=true"
          && currentPathString!="/about-us") {
            if (sessionStorage.getItem('userId')) {
              this.showMaintenanceForMinutesDialog(message);
            }else{
             this.showMaintenanceForHoursDialog(message);
            }
          }
          break;
        }
      }
      //Remove past date time actual list
      temporaryBeforeMinuteList.forEach((element) => {
        this.maintenanceService.maintenanceBeforeMinuteList = this.maintenanceService.maintenanceBeforeMinuteList.filter((data => data.minute != element.minute));
      });

      console.log("Final Minute Arraylist --", this.maintenanceService.maintenanceBeforeMinuteList);
    }
    //Check Seconds if any part of the requirement
    //....
    //
    else { }

  }
  //A method to navigate to maintenance screen
  navigateToMaintenanceScreen() {
    this.router.navigate(['']);
    //Reload current path if the user is in the landing page
    let currentPathString = location.pathname;
    if (currentPathString == "/") {
      this.reloadCurrentRoute();
    }
    //Set a session flag to prevent back button
    sessionStorage.setItem("preventBackButton", "true");
  }

  showMaintenanceForHoursDialog(message: string) {
    //show dialog message
    const dialogRefDuplicate = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '600px',
      data: {
        oneButton: true,
        labelVal3: message,
        primaryButVal: 'OK',
        showMaintenanceIcon:true
      },
    });
    dialogRefDuplicate.afterClosed().subscribe((res) => {
      if (res.data == 'OK') {
        return;
      }
    });
  }

  showMaintenanceForMinutesDialog(message: string) {
    //show dialog message
    const dialogRefDuplicate = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '700px',
      data: {
        oneButton: true,
        labelVal4: message,
        primaryButVal: 'OK',
        showMaintenanceIcon:true
      },
    });
    dialogRefDuplicate.afterClosed().subscribe((res) => {
      if (res.data == 'OK') {
        return;
      }
    });
  }

  showFooter() {
    var pathString = location.pathname;
    if (pathString.includes("/Claimant") || pathString.includes("/CompanyOrIndividual")) {
      return false;
    } else {
      return true;
    }
  }
  openDialog(): any {
    this.dialog.closeAll();
    var pathString: string = location.pathname;
    if (pathString === "/") {
      this.hideTimeout = true;
      this.duration = 55 * 60 * 1000;
      this.isTerm = true;
      return;
    }
    else {
      this.hideTimeout = false;
    }
    const dialogRef = this.dialog.open(NotificationTimeoutComponent, {
      disableClose: true,
      width: '350px',
      panelClass: 'notification-timeout',
      data: {
        isTerms: this.isTerm,
      }
    });
    this.duration = 5 * 60 * 1000;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.duration = 55 * 60 * 1000;
        this.isTerm = true;
        clearTimeout(this.timeoutId);
        this.checkTimeOut();
      }
      else if (result != undefined && !result) {
        clearTimeout(this.timeoutId);
        sessionStorage.clear();
        this.duration = 5 * 60 * 1000;
        this.isTerm = true;
        this.checkTimeOut();
      }
    });
  }



  ngOnDestroy() {
    clearTimeout(this.timeoutId);
  }

  unsubscribeMaintenanceTimer() {
    if (this.maintenanceTimer) {
      this.maintenanceTimer.unsubscribe();
    }
  }
  //A method to reload current route
  reloadCurrentRoute() {
    window.location.reload();
  }
  //A method to prevent browser back button
  preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    }); 
  } 
  //A method to check and hide footer menus
  hideFooterMenu(){
    if(this.maintenanceDetail?.isMaintenanceInProgress 
      || sessionStorage.getItem("isServerUnavailable")=="true"){
      return true;
    }
    else{
      return false;
    }
  }
}
